import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { SrUsersGet, SrUserService } from '@app/services/sr-user.service';

@Component({
  selector: 'tt-sr-users',
  templateUrl: './sr-users.component.html',
  styleUrls: ['./sr-users.component.css'],
  standalone: false,
})
export class SrUsersComponent implements OnInit, OnDestroy {
    public page?: SrUsersGet;
    public items: Item[] = [];
    public searching = false;
    public error = '';
    private requestRevision = 0;
    private activeSearch = '';
    private destroyed = false;
    constructor(private users: SrUserService, @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) { this.navigator = useNavigatorFor(navigator, this); }
    public async ngOnInit(): Promise<void> {
        try { const page = await this.users.getUsersSettings(); if (!this.destroyed) { this.page = page; await this.searchUsers(); } }
        catch (error) { this.showError(error); }
    }
    public async searchUsers(): Promise<void> {
        if (!this.page || typeof this.page.searchtext !== 'string' || typeof this.page.show_deleted_users !== 'string') return;
        const key = JSON.stringify([this.page.searchtext, this.page.show_deleted_users]);
        if (this.searching && key === this.activeSearch) return;
        this.activeSearch = key;
        const revision = ++this.requestRevision;
        this.searching = true;
        this.items = [];
        this.error = '';
        try {
            const items = await this.users.getUsers(this.page.searchtext, this.page.show_deleted_users);
            if (revision === this.requestRevision && !this.destroyed) this.items = items;
        } catch (error) { if (revision === this.requestRevision && !this.destroyed) this.showError(error); }
        finally { if (revision === this.requestRevision) this.searching = false; }
    }
    public onSearchTextChanged(value: string): void { if (this.page && value !== this.page.searchtext) { this.page.searchtext = value; if (!value) void this.searchUsers(); } }
    public onDeletedUsersChanged(value: string | undefined): void { if (this.page && value !== undefined && value !== this.page.show_deleted_users) { this.page.show_deleted_users = value; void this.searchUsers(); } }
    public newUser(): void { this.navigator?.go({ to: 'sruser-test', parms: { portal_user_keyno: '0' } }); }
    public openUser(event: { item: Item; event: MouseEvent }): void {
        if (!event.item.item_state || event.item['item_path'] === '') return;
        const to = event.item.item_state === 'sruser' ? 'sruser-test' : event.item.item_state;
        const target = { to, parms: event.item.item_parms };
        if (event.event.ctrlKey) this.navigator?.newTab(target); else this.navigator?.go(target);
    }
    private showError(error: unknown): void { this.error = error instanceof Error ? error.message : String(error); }
    public ngOnDestroy(): void { this.destroyed = true; ++this.requestRevision; }

}
